import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
import { RentalReportFilterModel } from 'src/app/models/rental/rental-report-filter.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { ClientService } from 'src/app/services/archive/client.service';
import { CostCenterPriceService } from 'src/app/services/archive/cost-center-price.service';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { RentalReportService } from 'src/app/services/rental/rental-report.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-cost-center-discounts',
  templateUrl: './cost-center-discounts.component.html',
  styleUrls: ['./cost-center-discounts.component.scss'],
  standalone: false
})
export class CostCenterDiscountsComponent implements OnInit {

  branchId: number = 0;
  changeFilters: boolean = false;
  costCenterContract: CostCenterModel = new CostCenterModel();
  dataReport: CustomTableReport;
  filtersHeight: number = 0;
  formRentalReportFilter: FormGroup = new FormGroup({});
  listArticle: any[] = [];
  listBranch: any[] = [];
  listClient: any[] = [];
  listCostCenter: any[] = [];
  nameWindow: string = 'Informe Descuentos por C.Costos';
  projectName = ProjectName.projectName;

  constructor(
    private articleService: ArticleService,
    private branchService: BranchService,
    private clientService: ClientService,
    private costCenterService: CostCenterService,
    private costCenterPriceService: CostCenterPriceService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private rentalReportService: RentalReportService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.getFirstBranchByUserAuthenticatedAsync();
    await this.getAllLists();
  }

  changeArticle(articleId: number | null) {
    if (articleId === 0 || articleId === null || articleId === undefined) {
      this.formRentalReportFilter.controls["articleId"].patchValue(0);
    } else {
      this.changeFilter();
    }
  }

  changeClient(clientId: number | null) {
    if (clientId === 0 || clientId === null || clientId === undefined) {
      this.formRentalReportFilter.controls["clientId"].patchValue(0);
    } else {
      this.changeFilter();
      this.formRentalReportFilter.controls["costCenterId"].patchValue(0);
    }
  }

  async changeCostCenter(costCenterId: number | null) {
    try {
      if (costCenterId) {
        await this.getCostCenterById(costCenterId);
        this.formRentalReportFilter.controls["clientId"].patchValue(this.costCenterContract.clientId);
        this.changeFilter();
      } else {
        this.formRentalReportFilter.controls["costCenterId"].patchValue(0);
      }
    } catch (error) {
      console.error('Error al cambiar el centro de costos:', error);
    }
  }

  changeFilter() {
    this.changeFilters = false;
  }

  clear() {
    this.changeFilter();
    this.validateForm();
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  async exportExcel() {
    if (this.changeFilters) {
      const modelRentalReportFilter = this.formRentalReportFilter.value as RentalReportFilterModel;
      if (modelRentalReportFilter.typeReport === 1) {
        modelRentalReportFilter.byStores = false;
      } else {
        modelRentalReportFilter.byStores = true;
      }

      try {
        const response = await firstValueFrom(this.rentalReportService.exportRentalReportCostCenterDiscounts(modelRentalReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Informe Descuentos por C.Costos.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  async getAllLists() {
    try {
      const [branches, clients, costCenters, articles,] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.clientService.getAllClientsForSelectAsync()),
        firstValueFrom(this.costCenterPriceService.getAllCostCentersForSelectAsync(this.branchId, 0)),
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
      ]);
      this.listArticle = articles;
      this.listBranch = branches;
      this.listClient = clients;
      this.listCostCenter = costCenters;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getBranch(branchId: number | null, change: boolean) {
    if (branchId && branchId != 0) {
      this.branchId = branchId;
      await this.getAllLists();
      if (change) {
        this.changeFilter();
        this.formRentalReportFilter.controls["costCenterId"].patchValue(0);
        this.formRentalReportFilter.controls["articleId"].patchValue(0);
        this.formRentalReportFilter.controls["clientId"].patchValue(0);
      }
    } else {
      this.branchId = 0;
    }
  }

  async getCostCenterById(costCenterId: number) {
    try {
      this.costCenterContract = await firstValueFrom(this.costCenterService.getCostCenterById(costCenterId));
    } catch (error) {
      console.error('Error al cargar el centro de costos:', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      await this.getBranch(response.branchId, true);
      this.formRentalReportFilter.controls["branchId"].patchValue(response.branchId);
    } catch (error) {
      console.error("Error al consultar la sucursal:", error);
    }
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  async send() {
    Object.keys(this.formRentalReportFilter.controls).forEach(key => {
      const control = this.formRentalReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formRentalReportFilter.valid) {
      const modelRentalReportFilter = this.formRentalReportFilter.value as RentalReportFilterModel;
      try {
        this.dataReport = await firstValueFrom(this.rentalReportService.rentalReportCostCenterDiscounts(modelRentalReportFilter));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      clientId: {
        notNumber: 'Debe seleccionar un Cliente válido.'
      },
      costCenterId: {
        notNumber: 'Debe seleccionar un C.Costos válido.'
      },
      articleId: {
        notNumber: 'Debe seleccionar un Artículo válido.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formRentalReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    this.formRentalReportFilter = this.formBuilder.group({
      typeReport: [1, [Validators.required]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      clientId: [0, [CustomValidators.numberOnlyValidator()]],
      costCenterId: [0, [CustomValidators.numberOnlyValidator()]],
      articleId: [0, [CustomValidators.numberOnlyValidator()]],
      articleName: [""]
    });
  }
}